export default __webpack_public_path__ + "static/media/reset-password-bg.70bfb048.png";